import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { QuoteRepository } from '../../../domain/repositories/quote/quote.repository';
import { CreateQuoteRequest, CreateQuoteResponse } from '../../../domain/interfaces/quote/quote.interface';
import { QuoteService } from '../../services/quote/quote.service';

@Injectable({ providedIn: 'root' })
export class QuoteRepositoryImplementation extends QuoteRepository {
  private readonly quoteService = inject(QuoteService);

  createQuote(request: CreateQuoteRequest): Observable<CreateQuoteResponse> {
    return this.quoteService.createQuote(request);
  }
}
